import { createWebStoragePersistor } from 'react-query/createWebStoragePersistor-experimental';
export default createWebStoragePersistor({
    storage: window.sessionStorage,
});
//# sourceMappingURL=StoragePersistor.web.js.map